import { render, staticRenderFns } from "./ClientCMSAgentStatus.vue?vue&type=template&id=585a4d65&scoped=true&"
import script from "./ClientCMSAgentStatus.vue?vue&type=script&lang=js&"
export * from "./ClientCMSAgentStatus.vue?vue&type=script&lang=js&"
import style0 from "./ClientCMSAgentStatus.vue?vue&type=style&index=0&id=585a4d65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a4d65",
  null
  
)

export default component.exports